import { style } from 'typestyle';
import { RED_PRIMARY, TEAL_PRIMARY, TEAL_PRIMARY_INPUTS } from 'src/utils/Style/Theme';
import { extraSmallFont } from 'src/utils/Style/Theme';

export const BottomBarContainer = style({
  minHeight: '1.25rem',
  lineHeight: 1.5,
  $nest: {
    '.summary': {
      fontSize: extraSmallFont,
      opacity: 0.8,
      padding: '0.375rem 0 0.185rem',
      display: 'flex',
      flex: 1,
      justifyContent: 'space-between',
      $nest: {
        '&-description': {
          marginBottom: 0,
          marginLeft: 0,
          $nest: {
            '&:not(:last-of-type)::after': {
              content: '" | "',
              marginRight: '0.185rem',
            },
          },
        },
        '&-error': {
          color: RED_PRIMARY,
          margin: '0 0 0 auto',
        },
        '&-list': {
          display: 'flex',
          marginBottom: 0,
          marginTop: 0,
        },
        '&-term': {
          fontWeight: 400,
          $nest: {
            '&::after': {
              content: '": "',
              marginRight: '0.185rem',
            },
          },
        },
      },
    },
  },
});

export const LookBackContainer = style({
  display: 'flex',
  $nest: {
    '.look-back': {
      display: 'flex',
      marginRight: '10px',
      $nest: {
        'input[type="radio"]': {
          fontSize: '0.5rem',
        },
        'input[type="radio"]:checked': {
          accentColor: TEAL_PRIMARY_INPUTS,
        },
        'input[type="radio"]:checked+label': {
          color: TEAL_PRIMARY,
        },
        '.radio-group': {
          display: 'flex',
          // center is still a bit high due to container bounds
          alignItems: 'end',
        },
        '.radio-group > label': {
          fontSize: '0.5rem',
          padding: '0 10px 0 5px',
          textTransform: 'uppercase',
        },
      },
    },
  },
});
